import './PartItem.css';
import React from 'react';
import {connect} from 'react-redux';
import * as _ from 'lodash';

import * as ReactDataGrid from 'react-data-grid';
import {Editors, Formatters} from 'react-data-grid-addons';

import {Box} from 'reactjs-admin-lte';
import {FormControl, FormGroup, ControlLabel, Button} from 'react-bootstrap';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import {
  loadPartList,
} from '../../../../stores/CarDamage/PartReducer';
import {
  loadPartItem,
} from '../../../../stores/CarDamage/PartItemReducer';
import {
  setCarSize,
  setPartType,
} from '../../../../stores/CarDamage/CarReducer';
import {updateDamageItemByPartItem} from '../../../../stores/CarDamage/DamageReducer';
import NewPartItemModal from './../NewPartItemModal/NewPartItemModal';
import {loadWageList} from '../../../../stores/CarDamage/WageReducer';

class PartItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      new_part_modal: false,
    };
  }


  getPartGroupSelect() {
    return _.map(this.props.partList, (item) => ({
      label: `${item.description} (${item.description_en})`,
      options: _.map(item.sublist, (sub_item) => ({
        label: sub_item.group_id,
        label: `${sub_item.description} (${sub_item.description_en})`,
      })),
    }));
  }

  partTypeChange = (e) => {
    const {props} = this;

    const partType = e.target.value;
    if (!partType) {
      return false;
    }

    props.dispatch(setPartType({partType}));
    props.dispatch(loadPartItem({
      ...props.car,
      partType,
    }));

  };

  renderTableData() {
    const {props, state} = this;
    const {dispatch, car} = props;

    return (
        <div>
          <div className="table-responsive form-group"
               style={{maxHeight: '350px', overflow: 'auto'}}>
            <table
                className={'table table-bordered table-striped table-hover table-bordered-solid'}>
              <thead>
              <tr>
                <th className={'selectRow'}></th>
                <th>รายการอะไหล่</th>
                <th>รายการอะไหล่ (EN)</th>
              </tr>
              </thead>
              <tbody>
              {props.partItem.map(
                  (item, index) => this.renderTableRow(item, index))}
              </tbody>
            </table>
          </div>

          <FormGroup>
            <NewPartItemModal
                partList={props.partList}
                show={state.new_part_modal}
                onSave={_ => dispatch(loadPartItem(car))}
                onHide={_ => this.setState(
                    {new_part_modal: false})}
                {...car}
            />
            <Button bsStyle={'success'}
                    onClick={_ => this.setState({new_part_modal: true})}
            >+ เพิ่มรายการ</Button>
          </FormGroup>
        </div>
    );
  }

  updateItem = (item, field) => (e) => {
    let updated = {
      detail: item.description,
      itemnum: item.part_id,
      [field]: e.target.checked && 1 || 0,
    };
    this.props.dispatch(updateDamageItemByPartItem({
      itemnum: item.part_id,
      updated,
    }));
  };

  renderTableRow(item, index) {
    const {props} = this;
    const {damageList} = props;
    const checked = !!_.find(damageList,
        damageItem =>
            item.part_id == damageItem.itemnum
            && damageItem.part_flag == 1);

    return (
        <tr key={index} className={
          [(checked ? 'success' : '')].join(' ')
        }>
          <td className={'text-center'}>
            <input type={'checkbox'}
                   onChange={this.updateItem(item, 'part_flag')}
                   checked={checked} />
          </td>
          <td>{item.description}</td>
          <td>{item.description_en}</td>
        </tr>
    );
  }

  render() {
    const {props} = this;
    const {dispatch} = props;
    return (
        <div className={'car-part-stock-list'}>
          <Box loading={props.loading.partGroup || props.loading.partType}>
            <Box.Body>
              <FormGroup>
                <span
                    className="label label-default car-info">
                  {props.car.carDetail}
                  </span>
              </FormGroup>
              <FormGroup>
                {props.car.partID <= 0
                    ? 'เลือกตำแหน่ง 1-13 จุดเสียหายเพื่อแสดงชิ้นส่วนอะไหล่'
                    : <div><FormGroup controlId="formControlsSelect">
                      <ControlLabel>เลือกประเภทอะไหล่</ControlLabel>
                      <FormControl componentClass="select"
                                   onChange={this.partTypeChange}
                                   placeholder="เลือกประเภทอะไหล่">
                        <option value={''}>เลือกกลุ่มอะไหล่</option>
                        {props.partList.map((item, index) => (
                            <optgroup key={index}
                                      label={`${item.description} (${item.description_en})`}>
                              {item.sublist.map((subitem, index) => (
                                  <option key={index}
                                          value={subitem.group_id}>
                                    {subitem.description} ({subitem.description_en})
                                  </option>
                              ))}
                            </optgroup>
                        ))}
                      </FormControl>
                    </FormGroup>
                      {props.car.partType ? this.renderTableData() : ''}
                    </div>
                }
              </FormGroup>
            </Box.Body>
          </Box>
        </div>
    );
  }
}

export default connect(
    (state, props) => ({...state, ...props}),
)(PartItem);


// WEBPACK FOOTER //
// ./src/component/element/CarDamageForm/PartItem/PartItem.js